import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dcbbada6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dcbbada6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbbada6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcbbada6')) {
      api.createRecord('dcbbada6', component.options)
    } else {
      api.reload('dcbbada6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dcbbada6&scoped=true", function () {
      api.rerender('dcbbada6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PPT/index.vue"
export default component.exports